<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-account-sync"
      title="Endre ansvarlig"
      btnActionName="Lagre"
      @action="save"
    >
      <template v-slot>
        <v-text-field
          :value="responsible"
          class="mb-5"
          prepend-inner-icon="mdi-account"
          color="primary"
          label="Nåverende ansvarlig"
          filled
          hide-details
          readonly
          disabled
        ></v-text-field>
        <!-- :contactId.sync="complaint.contactId" -->
        <v-form v-model="valid" ref="form">
          <ContactPersonPicker
            v-if="!items"
            v-model="newResponsible"
            :contactId.sync="newContactId"
            label="Ny ansvarlig"
            prepend-inner-icon="mdi-account-sync"
            :rules="[(v) => !!v || 'Ny ansvarlig er ikke valgt!']"
          ></ContactPersonPicker>

          <v-autocomplete
            v-if="items"
            v-model="newResponsible"
            :items="items"
            filled
            label="Ny ansvarlig"
            prepend-inner-icon="mdi-account-sync"
            item-text="value"
            item-value="key"
            hide-no-data
            :rules="[(v) => !!v || 'Ny ansvarlig er ikke valgt!']"
            :required="true"
          ></v-autocomplete>
        </v-form>

        <!-- <v-alert color="info" border="left" dark>
          Duis arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis,
          ipsum. Suspendisse non nisl sit amet velit hendrerit rutrum.
        </v-alert> -->
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import ContactPersonPicker from "@/components/shared/field/ContactPersonPicker.vue";
export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    responsible: {
      type: String,
    },
    items: {
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      newResponsible: null,
      newContactId: null,
    };
  },
  methods: {
    save() {
      var valid = (this as any).$refs.form.validate();
      if (valid) {
        this.$emit("save", this.newResponsible, this.newContactId);
        (this as any).$refs.form.reset();
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },

  components: {
    BaseDialog,
    ContactPersonPicker,
  },
});
</script>
